import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { apiEndpointURL } from '@app/core/constants/endpoints-url';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private httpClient = inject(HttpClient);

  getUserDetails(email: any): Observable<any> {
    return this.httpClient.get([apiEndpointURL.getUserDetail, email].join('/'));
  }

  getCountryData(): Observable<any> {
    const params = new HttpParams().set('headerNotRequired', true);
    return this.httpClient.get(apiEndpointURL.countryListJson, { params });
  }

  fetchStateDetails(countryId: any) {
    const url = [apiEndpointURL.getCountryEndpoint, countryId, "states"].join('/');
    return this.httpClient.get(url);
  }

  fetchDistrictDetails(countryId: any, stateId: any) {
    const url = [apiEndpointURL.getCountryEndpoint, countryId, "states", stateId, "districts"].join('/');
    return this.httpClient.get(url);
  }

  getFeatureFlag(token: string, projectId: string, featureFlagId?: any) {
    const params = new HttpParams().set('headerNotRequired', true);
    const headers = new HttpHeaders().set('Authorization', ('Bearer ' + token));
    let url = [apiEndpointURL.gitlabFeatureFlagDetails, projectId, 'feature_flags'].join('/');
    if (featureFlagId)
      url = [url, featureFlagId].join('/')
    return this.httpClient.get(url, { headers, params });
  }
}
